import React from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import avtar from "../../assets/images/Profile-Picture.jpg";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { red } from '@mui/material/colors';
import { Box } from '@mui/material';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 10,
  p: 3,
};
function MobileServiceProviderDetails() {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [stopServiceModal, setStopServiceModal] = React.useState(false);
    const handleOpenStopService = () => setStopServiceModal(true);
    const handleCloseStopService = () => setStopServiceModal(false);
  return (
    <div>
      <div className="drawerFixedPatch"></div>
      <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
          className="backArrowMobil"
          onClick={() => navigate("/MobileServiceProvider")}
        />
        <h1>Service Provider Details</h1>
      </div>
      <div className="sectionMobile">
        <div className="sectionMobile">
          <div className='spMainDiv'>
          <div className="mobProHed">
            <div className='AddServiceProviderView'>
              <div className='StopServiceBtnView' onClick={handleOpenStopService}>
                <p className='StopBtnTxt'>Stop Services</p>
              </div>
            </div>
            <div className="mobProHedInr">
              <div className="mobProHedInrProOut">
                <div className="mobProHedInrProFilePic">
                  <img src={avtar} alt='altimg'/>
                </div>
              </div>
              <h1>Namrata Patil</h1>
              <p>22 Reviews</p>
            <div className="ServiceDetailView">
            <div className='ServiceProviderDetails'>
              <p className='SPNameTxt'>Phone Number</p>
              <p className='SPPhoneTxt'>(205)555-0111</p>
            </div>
            <div className='ServiceProviderDetails'>
              <p className='SPNameTxt'>Address</p>
              <p className='SPPhoneTxt'>8502 Main Road Panchawati Nashik 422003</p>
            </div>
            <div className='ServiceProviderDetails'>
              <p className='SPNameTxt'>Age</p>
              <p className='SPPhoneTxt'>25 Years</p>
            </div>
            <div className='ServiceProviderDetails'>
              <p className='SPNameTxt'>Service Type</p>
              <p className='SPPhoneTxt'>Maid</p>
            </div>
            <div className='ServiceProviderDetails'>
              <p className='SPNameTxt'>Qualification</p>
              <p className='SPPhoneTxt'>SSC</p>
            </div>
            <div className='ServiceProviderDetails'>
              <p className='SPNameTxt'>Houses Working</p>
              <p className='SPPhoneTxt'>Wing A 502, Wing B 202</p>
            </div>
            <div className='ServiceProviderDetails'>
              <p className='SPNameTxt'>Register Since</p>
              <p className='SPPhoneTxt'>19/08/2021</p>
            </div>
            </div>
            </div>
          </div>
          <div className='ReviewsView'>
            <p className='SpReviewTxt'>Reviews</p>
            <div className="famDetailsListInrMob">
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro" onClick={()=> navigate('/MobileServiceProviderDetails')}>
            <div className="ImageViewRound">
            <img src={avtar} className="useImage" alt='altimg'/>
            </div>
            <div className="detailsDiMob">
              <h1>User Name</h1>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
          <div>
          <p className='ticketTimedeteTxt'>02/10/2022 12:01 am</p>
          </div>
        </div>
        <div className='dividerCommon' />
        <div className='famDetailsListTo'>
        <div className='pollsTitlDescView'>
          <p className='pollsDescripTxt'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam interdum est sed felis tempus</p>
        </div>
        </div>
        </div>
          </div>
          </div>
        </div>
      </div>
      <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
        <Box sx={style}>
          <div className='modalTitleView'>
            <p className='modalTitleTxt'>Add Time Slot</p>
            <CloseIcon sx={{ color: red[600], fontSize: 25 }} onClick={handleClose} />
          </div>
          <div className='FormView'>
            <div className='lebalInputView'>
            <p className='inputLebal'>In Time</p>
            <input type='datetime-local' className='titleInput'/>
            </div>
            <div className='lebalInputView'>
            <p className='inputLebal'>Out Time</p>
            <input type='datetime-local' className='titleInput'/>
            </div>
            <button className='submitButton' type='submit'>Add To Household</button>
          </div>
        </Box>
      </Modal>
      <Modal
            open={stopServiceModal}
            onClose={handleCloseStopService}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
        <Box sx={style}>
          <div className='modalTitleView'>
            <p className='modalTitleTxt'>Stop Services</p>
            <CloseIcon sx={{ color: red[600], fontSize: 25 }} onClick={handleCloseStopService} />
          </div>
          <div className='FormView'>
            <div className='lebalInputView'>
            <p className='inputLebal'>Enter Message</p>
            <input type='text' className='titleInput'/>
            </div>
            <button className='submitButton' type='submit'>Stop Services</button>
          </div>
        </Box>
      </Modal>
      <div className='bottomBtnView'>
        <button className='submitButton' onClick={handleOpen}>Add To Household</button>
      </div>
    </div>
  )
}

export default MobileServiceProviderDetails